import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { SubmitButton } from "@/common/components/buttons/submit-button/SubmitButton";
import { FormShell } from "@/common/components/forms/FormShell";
import { TextField } from "@/common/components/forms/text-field/TextField";

import {
  MANUAL_FARM_INITIAL_VALUES,
  manualFarmSchema,
  type ManualFarmFormValues,
} from "./farmImport.schema";
import { useCreateEmptyFarmMutation } from "./signup.api";

type Props = {
  countryCode: string;
};

const ManualFarmForm = ({ countryCode }: Props): React.ReactElement => {
  const navigate = useNavigate();
  const createEmptyFarmMutation = useCreateEmptyFarmMutation();

  const handleSubmit = (values: ManualFarmFormValues) => {
    createEmptyFarmMutation.mutate(
      { countryCode, farmName: values.farmName },
      { onSuccess: () => navigate("/farm") },
    );
  };

  return (
    <FormShell<ManualFarmFormValues>
      initialValues={MANUAL_FARM_INITIAL_VALUES}
      onSubmit={handleSubmit}
      validationSchema={manualFarmSchema}
      footer={
        <SubmitButton
          data-testid="create-farm-submit"
          pending={createEmptyFarmMutation.isPending}
        >
          <FormattedMessage id="common.loadAndEnter" />
        </SubmitButton>
      }
    >
      <TextField
        fullWidth
        label={<FormattedMessage id="common.farmName" />}
        name="farmName"
      />
    </FormShell>
  );
};

export { ManualFarmForm };
